import React from 'react';
import BS from '@/styles/btnStyled';
import { downloadExcel } from '@/utils/excelUtils';

interface ExcelDownloadButtonProps {
  headers: { label: string; key: string }[];
  data: any[] | null;
  fileName: string;
  sheetName?: string;
  buttonText?: string;
}

const ExcelDownloadButton: React.FC<ExcelDownloadButtonProps> = ({
  headers,
  data,
  fileName,
  sheetName,
  buttonText = '엑셀 다운로드',
}) => {
  const handleDownload = () => {
    if (!data) return;
    downloadExcel({ headers, data, fileName, sheetName });
  };

  return (
    <BS.Btn1Type5 onClick={handleDownload} disabled={!data}>
      {buttonText}
    </BS.Btn1Type5>
  );
};

export default ExcelDownloadButton;
